import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import Header from './Footer.vue'

export default Node.create({
  name: 'Footer',

  group: 'block',

  // content: 'inline*',
  content: 'block*',

  parseHTML() {
    return [
      {
        tag: 'footer',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['footer', mergeAttributes(HTMLAttributes), 0]
  },

  addNodeView() {
    return VueNodeViewRenderer(Header)
  },
})